package org.catharsis.spendtel.core.auth

import dev.gitlive.firebase.auth.externals.GoogleAuthProvider as JsGoogleAuthProvider
import dev.gitlive.firebase.auth.externals.getAuth
import dev.gitlive.firebase.auth.externals.signInWithPopup
import kotlin.coroutines.resume
import kotlin.coroutines.suspendCoroutine

actual object GoogleSignInProvider {
    actual suspend fun getGoogleTokens(): Result<GoogleAuthTokens> = suspendCoroutine { continuation ->
        val auth = getAuth()
        val provider = JsGoogleAuthProvider()

        signInWithPopup(auth, provider)
            .then { userCredential ->
                if (userCredential.user == null) {
                    continuation.resume(Result.failure(Exception("Google sign-in failed.")))
                    return@then
                }

                // Popup already signed the user into Firebase. Tokens are unused on web;
                // AuthenticationRepoImpl reads firebaseAuth.currentUser instead.
                continuation.resume(
                    Result.success(
                        GoogleAuthTokens(
                            idToken = "web-popup-complete",
                            accessToken = null,
                        ),
                    ),
                )
            }
            .catch { error ->
                if (isFirebaseGoogleSignInCancelled(error)) {
                    continuation.resume(Result.failure(GoogleSignInCancelledException()))
                } else {
                    val message = error.message?.toString().orEmpty()
                    continuation.resume(
                        Result.failure(
                            Exception(message.ifBlank { "Google sign-in failed." }),
                        ),
                    )
                }
            }
    }
}

private fun isFirebaseGoogleSignInCancelled(error: dynamic): Boolean {
    val message = error.message?.toString().orEmpty()
    val code = error.code?.toString().orEmpty()
    return isGoogleSignInCancelled(Exception(message)) ||
        code.contains("popup-closed", ignoreCase = true) ||
        code.contains("cancelled", ignoreCase = true)
}
